
import React, { useState } from 'react';
import { Typography, Button, TextField, Divider } from '@mui/material';

export default function MqttSetup({
  handleNext,
  handleBack, 
  mqttBrokerIp,
  setMqttBrokerIp,
  mqttUsername,
  setMqttUsername,
  mqttPassword,
  setMqttPassword,
  mqttClientName,
  setMqttClientName,
  mqttPortNumber,
  setMqttPortNumber,
  mqttTopic,
  setMqttTopic,
  isConnected,
  handleRestart
}) {
  const isNextDisabled = !mqttBrokerIp || !mqttUsername || !mqttPassword || !mqttClientName || !mqttPortNumber || !mqttTopic;

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        MQTT 설정
      </Typography>
      <TextField
        label="Broker IP"
        variant="outlined"
        fullWidth
        required
        value={mqttBrokerIp}
        onChange={(e) => setMqttBrokerIp(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <TextField
        label="사용자 ID"
        variant="outlined"
        fullWidth
        required
        value={mqttUsername}
        onChange={(e) => setMqttUsername(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <TextField
        label="비밀번호"
        variant="outlined"
        type="password"
        fullWidth
        required
        value={mqttPassword}
        onChange={(e) => setMqttPassword(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <TextField
        label="클라이언트 이름"
        variant="outlined"
        fullWidth
        required
        value={mqttClientName}
        onChange={(e) => setMqttClientName(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <TextField
        label="포트 번호"
        variant="outlined"
        fullWidth
        type="number"
        required
        value={mqttPortNumber}
        onChange={(e) => setMqttPortNumber(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <TextField
        label="토픽 이름"
        variant="outlined"
        fullWidth
        required
        value={mqttTopic}
        onChange={(e) => setMqttTopic(e.target.value)}
        style={{ marginBottom: '8px' }}
      />
      <Divider style={{ margin: '12px 0 12px 0' }} />
      { isConnected ? (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={isNextDisabled}
            style={{ float: 'right' }}
          >
            다음
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleBack}
            style={{ float: 'right', margin: '0 8px' }}
          >
            이전
          </Button>
        </>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleRestart}
          style={{ float: 'right', margin: '0 8px' }}
        >
          처음으로
        </Button>
      )}
    </div>
  );
}
